import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'mobx-react';
import { create } from 'mobx-persist'
import './index.css';
import App from './App';
import userStore from './store/userStore'
import registerServiceWorker from './registerServiceWorker';
import { unregister } from './registerServiceWorker';
import axios from 'axios'

const hydrate = create({
    storage: localStorage,
    jsonify: true
})

hydrate('UserStore', userStore);

// Add a 401 response interceptor
axios.interceptors.response.use(function (response) {
  if ('ui-version' in response.headers){
    if (response.headers['ui-version'] !== userStore.ui_version_id){
      alert('A new version has been detected, your browser will now be reloaded.');
      userStore.setUiVersion(response.headers['ui-version']);
      window.location.reload(true);
      return false;
    } else {
      userStore.setUiVersion(response.headers['ui-version']);
    }
  }
  return response;
}, function (error) {
  if (401 === error.response.status) {
    userStore.logout();
  } else {
    return Promise.reject(error);
  }
});

var stores = {
  userStore
};

ReactDOM.render((
  <Provider {...stores}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>
), document.getElementById('root'));

//
// ReactDOM.render(<App />, document.getElementById('root'));

// registerServiceWorker();
unregister();



// WEBPACK FOOTER //
// ./src/index.js